import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/Auth";
import { getAuthRedirect } from "../features/auth/authRedirect";

function RequireNoAuth({ children }: { children: React.ReactNode }) {
  const { authData } = useAuth() as { authData: any };
  let location = useLocation();

  if (authData) {
    return (
      <Navigate
        to={getAuthRedirect(location)}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
}

export default RequireNoAuth;
